




























import { Component, Vue } from 'vue-property-decorator'
import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import store from '@/store'
import moment from 'moment'

@Component({
  components: {
    PageHead,
  },
})

export default class SnapshotList extends Vue {
  pageTitle = 'Restore Snapshot'
  callInProgress = false
  snapshotlist: SnapshotList = null

  get Helper() {
    return Helper
  }

  mounted() {
    this.fetchSnapshotList()
  }

  public async fetchSnapshotList() {
    this.callInProgress = true
    try {
      const snapshotlistResponse = await Api.fetchSnapshotList()
      this.snapshotlist = snapshotlistResponse.snapshotList
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public formatSnapshotDate(snapshotDate) {
    return moment(snapshotDate).format('dddd, MMMM Do YYYY')
  }

  public comfirmRestore(snapshotDate) {
    const h = this.$createElement
    this.$bvModal.msgBoxConfirm([h('span', { domProps: { innerHTML: 'Are you sure you want to restore the website contents from <b>' + this.formatSnapshotDate(snapshotDate) + '</b>?<br/><br/>This action can not be undone!' } })], {
      title: [h('span', { domProps: { innerHTML: '<b>Restore Confirmation!</b>' } })],
      size: 'md',
      buttonSize: 'sm',
      okVariant: 'success',
      cancelVariant: 'danger',
      okTitle: 'Proceed',
      cancelTitle: 'Cancel',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    }).then(value => {
      if (value) {
        this.restoreWebsiteContent(snapshotDate)
      }
    }).catch(err => {
      alert(err)
    })
  }

  public async restoreWebsiteContent(snapshotDate) {
    this.callInProgress = true
    try {
      await Api.restoreWebsiteContent(snapshotDate)
      this.callInProgress = false
      store.commit('toggleFlag')
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Website contents restored from ' + this.formatSnapshotDate(snapshotDate),
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}
